import React from 'react';
import cn from 'classnames';
import styles from './Copyright.module.scss';

const Copyright = ({ className = '' }) => (
  <div className={cn(styles.container, className)}>
    <p className={styles.copyright}>
      OBRIO ltd GREG TOWER, Floor 2, 7 Florinis Nicosia, 1065 CYP
    </p>
  </div>
);

export default Copyright;
